import { render, staticRenderFns } from "./HelpdeskCategories.vue?vue&type=template&id=04067595&scoped=true"
import script from "./HelpdeskCategories.vue?vue&type=script&lang=ts"
export * from "./HelpdeskCategories.vue?vue&type=script&lang=ts"
import style0 from "./HelpdeskCategories.vue?vue&type=style&index=0&id=04067595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04067595",
  null
  
)

export default component.exports